import React, { useState } from "react";
import images from "../../../assets/Icons/Icons";
import { SectionLoader } from "../../Loader/sectionLoader";
import SocialEmotionalCard from "./Cards/AcademicPerformence";
import StudentNotes from "./Cards/StudentsCard";

function NotesAboutStudent({
  schoolDashboardData,
  studentname,
  loading,
  userId,
  schoolHash,
  classId,
}: {
  schoolDashboardData: any;
  studentname: string;
  loading?: boolean;
  userId: string;
  schoolHash: string;
  classId: string;
}) {
  const [open, setOpen] = useState<boolean>(false);

  const toggleOpen = () => {
    setOpen(!open);
  };
  const AcademicTitle = `${studentname}'s` + " academic performance ";
  return (
    <section className="insight-section">
      <header onClick={toggleOpen} className="section-header">
        {/* <h3>Teacher Observations about {studentname}?</h3> */}
        <h3>TEACHER OBSERVATION ABOUT {studentname}</h3>
        <img
          src={open ? images.upIocn : images.downIcon}
          width={44}
          height={44}
        />
      </header>
      {open &&
        (loading ? (
          <SectionLoader />
        ) : (
          <>
            <div className="gap" />
            <div className="grid two">
              {/* <StudentNotes
                name={studentname}
                notes={schoolDashboardData?.notes}
                title="Academic performance"
              /> */}

              <SocialEmotionalCard
                schoolHash={schoolHash}
                classId={classId}
                userId={userId}
              />
            </div>
          </>
        ))}
    </section>
  );
}

export default NotesAboutStudent;
